import { render, staticRenderFns } from "./IntegrationInfo.vue?vue&type=template&id=28242b7d&"
import script from "./IntegrationInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./IntegrationInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports